import React, { useState } from 'react';

function RequestDeletePage({ onRequestDelete }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setMessage('');
    setSubmitting(true);

    try {
      await onRequestDelete(email, password);
      setMessage('Account deletion request has been made.');
    } catch (err) {
      setError(err.message || 'Wrong login info');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="page-shell auth-shell">
      <section className="auth-card">
        <span className="eyebrow">Account deletion</span>
        <h1>Request account deletion</h1>
        <p className="auth-subtitle">
          Enter your email and password to request account deletion.
        </p>

        <form className="auth-form" onSubmit={handleSubmit}>
          <label className="field-label">
            <span>Email</span>
            <input
              className="text-input"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="you@example.com"
              autoComplete="email"
            />
          </label>

          <label className="field-label">
            <span>Password</span>
            <input
              className="text-input"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="Your password"
              autoComplete="current-password"
            />
          </label>

          {error ? <div className="notice error-notice">{error}</div> : null}
          {message ? <div className="notice success-notice">{message}</div> : null}

          <button className="primary-button full-width" type="submit" disabled={submitting}>
            {submitting ? 'Submitting request...' : 'Request deletion'}
          </button>
        </form>
      </section>
    </main>
  );
}

export default RequestDeletePage;